<template>
    <div
      style="height:100%;width:1000px;color:#052F66;padding:20px 50px;background-color:rgb(245,245,220,0.90)"
    >
      <v-row>
        <v-col
          cols="12"
          sm="3"
        >
          <h6>My Account</h6>          
          <v-list
            dense
            nav
            style="background-color:transparent;"
          >
            <v-list-item
              v-if="!user.loggedIn"
              link
              @click="redirect('login')"
            >
              <v-list-item-icon>
                <v-icon>mdi-login</v-icon>
              </v-list-item-icon>

              <v-list-item-content
              >
                <v-list-item-title>Sign in</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-else
              link
              @click="redirect('login')"
            >
              <v-list-item-icon>
                <v-icon >mdi-login</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Sign out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="redirect('register')"
            >
              <v-list-item-icon>
                <v-icon>mdi-account-check</v-icon>
              </v-list-item-icon>

              <v-list-item-content
              >
                <v-list-item-title>Register</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="redirect('mydashboard')"
            >
              <v-list-item-icon>
                <v-icon>mdi-collage</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>My Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
          </v-list>
          
        </v-col> 
        <v-col
          cols="12"
          sm="3"
        >
          <h6>Products</h6>
          <v-list
            dense
            nav      
            style="background-color:transparent;"  
          >
            <v-list-item
              link
              @click="goToProduct('6')"
            >
              <v-list-item-icon>
                <v-icon>mdi-factory</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Engineering</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="goToProduct('5')"
            >
              <v-list-item-icon>
                <v-icon>mdi-water-pump</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Agriculture</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="goToProduct('1')"
            >
              <v-list-item-icon>
                <v-icon>mdi-car</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Motor Insurance</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="goToProduct('7')"
            >
              <v-list-item-icon>
                <v-icon>mdi-fire</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Fire Insurance</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
          </v-list>
        </v-col>
        <v-col
          cols="12"
          sm="3"
        >
          <h6>Services</h6>
          <v-list
            dense
            nav     
            style="background-color:transparent;"   
          >
            <v-list-item
              link
              @click="openDrawer"
            >
              <v-list-item-icon>
                <v-icon>mdi-receipt</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Get a Quote</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <v-list-item
              link
              @click="openBottomSheet(3)"
            >
              <v-list-item-icon>
                <v-icon>mdi-send</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Intimate a Claim</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="openBottomSheet(4)"
            >
              <v-list-item-icon>
                <v-icon>mdi-comment-alert</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Submit a Complaint</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="openBottomSheet(5)"
            >
              <v-list-item-icon>
                <v-icon>mdi-help-circle-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>Help</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col
          cols="12"
          sm="3"
        >
          <h6>Miscellaneous</h6>
          <v-list
            dense
            nav   
            style="background-color:transparent;"    
          >
            <v-list-item
              link
              @click="redirect('financials')"
            >
              <v-list-item-icon>
                <v-icon>mdi-download</v-icon>
              </v-list-item-icon>

              <v-list-item-content
                
              >
                <v-list-item-title>View Financials</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="redirect('terms')"
            >
              <v-list-item-icon>
                <v-icon>mdi-scale-balance</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Terms of Use</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>      
    </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'CorporateMenuModal',
    data() {
      return {
        
      }
    },
    methods: {
      redirect(path){
        this.$router.push(path);
      },
      goToProduct(index){   
        var path; 
        console.log(this.$route);
        if (this.$route.name == 'product_details'){
          path = index;
        }else{
          path = 'products/' + index;
        }  
        this.$router.push(path);      
      },
      openDrawer(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
      },
      openBottomSheet(index){
        this.components.bottom_sheet.option_index=index;
        this.components.bottom_sheet.is_open=true;
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    }  
  }
</script>
<style lang="css">
  .corpoate-menu-modal {
    transition: box-shadow 1s;
    position: absolute;
  }
</style>
